import { useDispatch, useSelector } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { FIND_PARTNERSHIP_BY_ID } from '../../../apollo';
import { StoreState } from '../../../redux';
import { partnershipSlice } from '../../../redux/partner/partnership';

export const usePartnershipByIdEffect = (callback?: (data: any) => void) => {
  const dispatch = useDispatch();
  const { data } = useSelector(
    (state: StoreState) => state.partner.partnership
  );

  const [doPartnership, { loading }] = useLazyQuery(FIND_PARTNERSHIP_BY_ID, {
    onCompleted: (data) => {
      dispatch(partnershipSlice.actions.update(data.findPartnershipById));
      if (callback) {
        callback(data.findPartnershipById);
      }
    },
    onError: (error) => {
      console.error(error);
      dispatch(
        partnershipSlice.actions.error('Retrieving partnership failed!')
      );
    },
  });

  const findPartnershipById = (id: number) => {
    const variables = { id };
    doPartnership({ variables });
    dispatch(partnershipSlice.actions.loading());
  };

  return {
    findPartnershipById,
    data,
    loading,
  };
};
